export default __webpack_public_path__ + "static/media/samma.9d5130b5.svg";